require('./bootstrap')
require('./deps/offline.min');
require('./deps/addtohomescreen');
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Toasted from 'vue-toasted';
import Vue2TouchEvents from 'vue2-touch-events'
import swal from 'sweetalert';
import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);
Vue.use(Vue2TouchEvents)

Vue.use(Toasted, {
  fullWidth: true,
  duration: 3000,
  position: 'bottom-center'
});
Vue.config.ignoredElements = [/^ion-/]
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
